import { GetPlacesForTagQuery } from 'API/tags-api';

export const tagsQueryKeys = {
    all: ['tags'] as const,
    delete: ['delete-tag'] as const,
    update: ['update-tag'] as const,
    create: ['create-tag'] as const,
    removeTagMembers: ['remove-tag-members'] as const,
    addTagMembers: ['add-tag-members'] as const,
};

export const placesWithTagsQueryKeys = {
    all: ['places-for-tags-compared'] as const,
    byTagId: ({ tagId }: any = {}) => [...placesWithTagsQueryKeys.all, tagId],
    filters: ({ id, ...otherParams }: Partial<GetPlacesForTagQuery> = {}) =>
        [...placesWithTagsQueryKeys.byTagId({ tagId: id }), otherParams] as const,
};
